function dm_header(){
    const body = document.body;
    const downThreshold = 64 + 18;
    const topThreshold = 2; // tolerance for “at top”
    let lastY = Math.max(0, window.pageYOffset || window.scrollY || 0);
    let ticking = false;

    function update() {
        ticking = false;
        const y = Math.max(0, window.pageYOffset || window.scrollY || 0);

        // At top: set and exit to avoid being cleared by direction logic
        if (y <= topThreshold) {
            body.classList.add('scrolling-top');
            body.classList.remove('scrolling-up', 'scrolling-down');
            lastY = y;
            return;
        } else {
            body.classList.remove('scrolling-top');
        }

        if (y > lastY) {
            if (y >= downThreshold) body.classList.add('scrolling-down');
            else body.classList.remove('scrolling-down');
            body.classList.remove('scrolling-up');
        } else if (y < lastY) {
            body.classList.add('scrolling-up');
            body.classList.remove('scrolling-down');
        }

        lastY = y;
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    requestAnimationFrame(update);
}

export { dm_header };